import {useEffect, useState} from "react";
import {worktimetracking} from "../request/worktimetracking";
import {checkLogin} from "../../../../@WUM/templates/default/Auth/service/AuthService";
import {error} from "../../../../@WUM/core/component/const/error.services";
import {clockTimingInterface, clockTrackingDataInterface} from "../request/clockTimingInterface";

export const ResponseCalculatedWorkingDays = (date: string, refreshCounter: number): true | clockTrackingDataInterface | undefined => {
    const [posts, setPosts] = useState<clockTrackingDataInterface>()
    const [isError, setIsError] = useState<boolean>(false)
    useEffect(() => {
        ;(async () => {
            await worktimetracking
                .calculatedWorkingDays(date)
                .then((data) => {
                    checkLogin(data)
                    setPosts(data)
                    //console.log(data);
                })
                .catch((err) => {
                    error(err)
                    setIsError(true)
                })
        })()

    }, [date, refreshCounter])

    return isError ? isError : posts
}

/**
 * Startet work time.
 */
export const StartWork = async (): Promise<clockTimingInterface | false> => {
    try {
        const data = await worktimetracking.startWork();
        checkLogin(data);
        return data;
    } catch (err) {
        error(err);
        return false;
    }
};

/**
 * Stop work time.
 */
export const StopWork = async (): Promise<clockTimingInterface | false> => {
    try {
        const data = await worktimetracking.stopWork();
        checkLogin(data);
        return data;
    } catch (err) {
        error(err);
        return false;
    }
};

/**
 * End time tracking for the day.
 */
export const EndDay = async (): Promise<clockTimingInterface | false> => {
    try {
        const data = await worktimetracking.endDay();
        checkLogin(data);
        return data;
    } catch (err) {
        error(err);
        return false;
    }
};

/**
 * Starts break.
 */
export const StartBreak = async (): Promise<clockTimingInterface | false> => {
    try {
        const data = await worktimetracking.startBreak();
        checkLogin(data);
        return data;
    } catch (err) {
        error(err);
        return false;
    }
};

/**
 * Stops break.
 */
export const StopBreak = async (): Promise<clockTimingInterface | false> => {
    try {
        const data = await worktimetracking.stopBreak();
        checkLogin(data);
        return data;
    } catch (err) {
        error(err);
        return false;
    }
};